import { useState } from 'react';
import { reviews } from '@/mocks/reviews';

export default function Reviews() {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-50 text-secondary-700 text-xs font-medium mb-4">
            mrds 用户评价
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            超过 50,000 用户的信赖之选
          </h2>
          <p className="text-foreground-500 text-base max-w-[600px] mx-auto leading-relaxed">
            听听使用 mrds 的真实用户怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${
                      i < review.rating ? 'ri-star-fill text-primary-400' : 'ri-star-fill text-foreground-200'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-4 line-clamp-4">
                &ldquo;{review.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/70">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <div className="text-foreground-900 text-sm font-medium">{review.name}</div>
                  <div className="text-foreground-500 text-xs">
                    {review.role}，{review.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}